module.exports = __webpack_public_path__ + "static/media/ae.1aab826c.svg";